import { render, staticRenderFns } from "./RolesForm.vue?vue&type=template&id=5b072ae8&scoped=true&"
import script from "./RolesForm.vue?vue&type=script&lang=js&"
export * from "./RolesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b072ae8",
  null
  
)

export default component.exports